import { ReactNode } from "react"
import { renderIcon } from "./icons"
import {
  isNavGroup,
  isNavSection,
  NavGroup,
  NavLeaf,
  NavNode,
  NavSection,
} from "./navigation.types"

export interface MenuItemModel {
  key: string
  label?: ReactNode
  type?: "group"
  icon?: ReactNode
  onClick?: () => void
  children?: MenuItemModel[]
}

export interface BuildMenuOptions {
  onSelect: (path: string) => void
}

const buildLeafItem = (leaf: NavLeaf, options: BuildMenuOptions): MenuItemModel => ({
  key: leaf.id,
  label: leaf.label,
  icon: renderIcon(leaf.iconName),
  onClick: () => options.onSelect(leaf.path),
})

const buildGroupItem = (group: NavGroup, options: BuildMenuOptions): MenuItemModel => ({
  key: group.id,
  label: group.label,
  icon: renderIcon(group.iconName),
  children: group.children.map((leaf) => buildLeafItem(leaf, options)),
})

const buildSectionItem = (section: NavSection, options: BuildMenuOptions): MenuItemModel => ({
  key: section.id,
  type: "group",
  label: section.label,
  children: section.children.map((child) =>
    isNavGroup(child) ? buildGroupItem(child, options) : buildLeafItem(child, options)
  ),
})

export function buildMenuItems(nodes: NavNode[], options: BuildMenuOptions): MenuItemModel[] {
  return nodes.map((node) => {
    if (isNavSection(node)) return buildSectionItem(node, options)
    if (isNavGroup(node)) return buildGroupItem(node, options)
    return buildLeafItem(node, options)
  })
}
